import { Button } from '@equitymultiple/react-eui';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';

import { GetStartedPages } from '../../constants';
import { externalContactLink } from '../../utils/constants';
import { launchIntercom } from '../../utils/launchIntercom';
import * as styles from './GetStarted.module.scss';

type Props = {
  variant?: GetStartedPages | 'default';
};

const GetStarted = ({ variant = 'default' }: Props) => {
  const getVariantImage = () => {
    switch (variant) {
      case GetStartedPages.Investment:
        return (
          <StaticImage
            src={'../../assets/illustrations/get-started-investment.png'}
            alt=""
            placeholder="blurred"
          />
        );
      case GetStartedPages.OurProcess:
        return (
          <StaticImage
            src={'../../assets/illustrations/get-started-our-process.png'}
            alt=""
            placeholder="blurred"
          />
        );

      default:
        return (
          <StaticImage
            src={'../../assets/illustrations/get-started-investment.png'}
            alt=""
            placeholder="blurred"
          />
        );
    }
  };

  return (
    <div className={`${styles.getStarted} darkContainer`}>
      <div className="container">
        <hr />
        <div className={`row ${styles.content}`}>
          <div className={`col-md-8 ${styles.mainContent}`}>
            <div>
              <h4 className="heading4">
                Not sure where to start? We’re standing by to help
              </h4>
              <p className={`${styles.subHeading} subHeading`}>
                Our dedicated Investor Relations Team is standing by to help
                simplify your real estate investing process.
              </p>
            </div>
            <div className={styles.buttons}>
              <Button onClick={launchIntercom} variant="white">
                Send a Message
              </Button>
              <Button
                variant="outlinedWhite"
                target="_blank"
                href={externalContactLink}
              >
                Schedule a Call
              </Button>
            </div>
          </div>
          <div className={`col-md-4 ${styles.imageContainer}`}>
            {getVariantImage()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStarted;
